/* ============================================================
   FLOWZA — theme behaviour (Shopify-adapted)
   Consolidates nav/home/pages/product prototype scripts, but reads
   everything from the Liquid-rendered DOM instead of a fake catalog.
   Safe to load on every page — every block is null-guarded.
   ============================================================ */
(function () {
  "use strict";

  // UI strings from snippets/fz-strings.liquid; the English here is the
  // fallback for a key that is missing.
  var fzT = window.fzT || {};
  function fillIn(s, o) { s = String(s); for (var x in o) s = s.split("[" + x + "]").join(o[x]); return s; }
  function tr(k, en, o) { return fillIn(fzT[k] || en, o); }
  function trn(k, n, one, other, o) {
    var f = fzT[k];
    return fillIn(f && window.fzPlural ? window.fzPlural(f, n) : fillIn(n === 1 ? one : other, { count: n }), o);
  }

  /* ---- Scroll reveal (robust; no IntersectionObserver dependency) ---- */
  function revealCheck() {
    var t = window.innerHeight * 0.94;
    document.querySelectorAll(".reveal:not(.in)").forEach(function (el) {
      if (el.getBoundingClientRect().top < t) el.classList.add("in");
    });
  }
  revealCheck();
  window.addEventListener("scroll", revealCheck, { passive: true });
  window.addEventListener("resize", revealCheck, { passive: true });
  [120, 400, 900].forEach(function (d) { setTimeout(revealCheck, d); });
  setTimeout(function () {
    document.querySelectorAll(".reveal").forEach(function (e) {
      e.classList.add("in");
      e.style.transition = "none"; e.style.opacity = "1"; e.style.transform = "none";
    });
  }, 1600);

  /* ---- Header shadow on scroll ---- */
  var head = document.getElementById("head");
  if (head) {
    var hs = function () { head.classList.toggle("scrolled", window.scrollY > 10); };
    window.addEventListener("scroll", hs, { passive: true });
    hs();
  }

  /* ---- Fixed top bar: reserve exact space below it ---- */
  var topbar = document.getElementById("fz-topbar");
  if (topbar) {
    var setBarOffset = function () {
      document.body.style.setProperty("--fz-topbar-h", topbar.offsetHeight + "px");
    };
    setBarOffset();
    window.addEventListener("resize", setBarOffset, { passive: true });
    window.addEventListener("load", setBarOffset);
  }

  /* ---- Search overlay (submits to Shopify /search) ---- */
  // Arabic shopping words -> the English the catalogue is indexed under.
  // Shopify's search doesn't serve Arabic suggestions, and product titles and
  // types are English in every language, so "جوارب" found nothing. Unknown
  // words pass through untouched. ponytail: a word list, not a search engine;
  // extend it when shoppers search for something new.
  var AR_TERMS = {
    "جوارب": "socks", "جواريب": "socks", "شراب": "socks", "جريب": "grip", "مسكة": "grip",
    "بيلاتس": "pilates", "يوغا": "yoga", "بار": "barre",
    "جمبسوت": "jumpsuit", "جمبسوتات": "jumpsuit", "باقة": "bundle", "باقات": "bundle",
    "طقم": "set", "أطقم": "set", "سيت": "set", "برا": "bra", "شورت": "shorts",
    "رياضية": "activewear", "ملابس": "activewear", "كريسماس": "christmas",
    "أسود": "black", "وردي": "rose", "كحلي": "navy", "كريمي": "cream", "عنابي": "wine"
  };
  function searchTerm(q) {
    if (!/[؀-ۿ]/.test(q)) return q;
    var hit = false;
    var out = q.split(/\s+/).map(function (w) {
      var k = w.replace(/[ً-ْـ]/g, "").replace(/^و(?=..)/, "").replace(/^ال/, "");
      if (AR_TERMS[k] || AR_TERMS[w]) { hit = true; return AR_TERMS[k] || AR_TERMS[w]; }
      return w;
    });
    return hit ? out.filter(function (w) { return !/[؀-ۿ]/.test(w); }).join(" ") || q : q;
  }
  // The search page's own form and the overlay both submit "q": translate it
  // on the way out so /ar/search?q=جوارب lands on socks.
  document.addEventListener("submit", function (e) {
    var f = e.target.closest('form[role="search"]');
    var qi = f && f.querySelector('[name="q"]');
    if (qi) qi.value = searchTerm(qi.value);
  }, true);

  var overlay = document.getElementById("search-overlay");
  if (overlay) {
    var input = overlay.querySelector("input[type=search]");
    var form = overlay.querySelector("form.search-bar");
    var scrim = overlay.querySelector(".search-scrim");
    var closeBtn = overlay.querySelector(".search-close");
    var searchRoute = (window.routes && window.routes.search_url) || "/search";
    function openSearch() {
      overlay.classList.add("open");
      document.body.style.overflow = "hidden";
      setTimeout(function () { if (input) input.focus(); }, 80);
    }
    function closeSearch() {
      overlay.classList.remove("open");
      document.body.style.overflow = "";
    }
    document.querySelectorAll("[data-search]").forEach(function (b) {
      b.addEventListener("click", function (e) { e.preventDefault(); openSearch(); });
    });
    if (scrim) scrim.addEventListener("click", closeSearch);
    if (closeBtn) closeBtn.addEventListener("click", closeSearch);
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeSearch(); });

    /* ---- Live predictive search (results stay in the overlay) ---- */
    var suggest = overlay.querySelector(".search-suggest");
    var results = overlay.querySelector(".search-results");
    var empty   = overlay.querySelector(".search-empty");
    var cats    = document.createElement("div");
    cats.className = "search-cats";
    if (results) results.parentNode.insertBefore(cats, results);

    function thumbHTML(p) {
      var img = (p.featured_image && p.featured_image.url) || p.image || "";
      if (img) return '<img class="sr-img" src="' + img + '" alt="" loading="lazy">';
      return "";
    }
    function renderResults(data) {
      var products = (data.resources && data.resources.results && data.resources.results.products) || [];
      var collections = (data.resources && data.resources.results && data.resources.results.collections) || [];

      cats.innerHTML = collections.map(function (c) {
        return '<a class="search-cat" href="' + c.url + '">' + c.title + '</a>';
      }).join("");

      if (!products.length && !collections.length) {
        results.innerHTML = "";
        empty.style.display = "";
        empty.textContent = tr("no_results", "No results. Try “grip”, “legging”, or “bundle”.");
        return;
      }
      empty.style.display = "none";
      results.innerHTML = products.map(function (p) {
        return '<a class="sr-card" href="' + p.url + '">' +
          '<div class="sr-illu">' + thumbHTML(p) + '</div>' +
          '<p class="sr-cat">' + (p.type || p.vendor || "") + '</p>' +
          '<p class="sr-name">' + p.title + '</p>' +
          '<p class="sr-price">' + (p.price || "") + '</p>' +
        '</a>';
      }).join("");
    }

    var t;
    function run(q) {
      q = searchTerm((q || "").trim());
      if (!q) { suggest.style.display = ""; cats.innerHTML = ""; results.innerHTML = ""; empty.style.display = "none"; return; }
      suggest.style.display = "none";
      empty.style.display = "none";
      results.innerHTML = '<p class="search-loading">' + tr("searching", "Searching…") + '</p>';
      // Under the locale root, so /ar gets Arabic titles back. Titles and types
      // stay English in every language, so off the default language the
      // (translated) description is searched too -- "جوارب" matches nothing else.
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
      var fields = "title,product_type,variants.title,vendor" + (root === "/" ? "" : ",body");
      var path = "search/suggest.json?q=" + encodeURIComponent(q) +
                 "&resources[type]=product,collection" +
                 "&resources[limit]=8&resources[options][unavailable_products]=last&resources[options][fields]=" + fields;
      function get(base) {
        return fetch(base + path, { headers: { Accept: "application/json" } }).then(function (r) {
          if (!r.ok) throw new Error(r.status);
          return r.json();
        });
      }
      // A language Shopify won't serve suggestions for (unpublished, or a 417
      // "Unsupported buyer locale") falls back to the default one rather than
      // showing "no results" for everything.
      get(root)
        .catch(function () { return root === "/" ? Promise.reject() : get("/"); })
        .then(renderResults)
        .catch(function () { results.innerHTML = ""; });
    }

    if (input) input.addEventListener("input", function () {
      clearTimeout(t); t = setTimeout(function () { run(input.value); }, 180);
    });

    var arr = '<svg class="pill-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
    overlay.querySelectorAll(".search-quick button").forEach(function (b) {
      if (!b.querySelector(".pill-arr")) b.insertAdjacentHTML("beforeend", arr);
      b.classList.remove("chip");
      b.addEventListener("click", function () {
        var q = b.dataset.q || b.textContent.trim();
        if (input) input.value = q;
        if (form) form.submit(); else run(q);
      });
    });
  }

  /* Region is fixed to United Arab Emirates · AED — no switcher. */

  /* ---- Mobile menu (scroll-locked: body is position-fixed while open so the
     page can never scroll behind the overlay — incl. iOS; scroll position is
     saved on open and restored on close via every close path) ---- */
  var mmenu = document.getElementById("mmenu");
  var burger = document.getElementById("burger");
  var mclose = document.getElementById("mclose");
  if (mmenu && burger) {
    var savedY = 0, menuOpen = false;
    function openMenu() {
      if (menuOpen) return;
      menuOpen = true;
      savedY = window.scrollY || document.documentElement.scrollTop || 0;
      document.body.style.position = "fixed";
      document.body.style.top = -savedY + "px";
      document.body.style.left = "0";
      document.body.style.right = "0";
      document.body.style.width = "100%";
      mmenu.classList.add("open");
      // Body-level hook so fixed overlays can stand down while the menu is up,
      // the same way they do for the cart drawer. Without it the consent notice
      // sat on the menu's own "Shop grip socks" button.
      document.body.classList.add("fz-menu-open");
      burger.setAttribute("aria-expanded", "true");
    }
    function closeMenu() {
      if (!menuOpen) return;
      menuOpen = false;
      mmenu.classList.remove("open");
      document.body.classList.remove("fz-menu-open");
      burger.setAttribute("aria-expanded", "false");
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.left = "";
      document.body.style.right = "";
      document.body.style.width = "";
      window.scrollTo(0, savedY);
    }
    burger.addEventListener("click", function () { menuOpen ? closeMenu() : openMenu(); });
    if (mclose) mclose.addEventListener("click", closeMenu);
    mmenu.querySelectorAll("a").forEach(function (a) { a.addEventListener("click", closeMenu); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeMenu(); });
    window.addEventListener("pageshow", function (e) { if (e.persisted) closeMenu(); });
  }

  /* Removed: hero carousel (#hpc), best-sellers arrows (#bs-track) and the
     .pcard mini-sliders ([data-card-slider]) all targeted markup that no
     longer exists anywhere in the theme, and shipped on every page view. */

  /* ---- Testimonial carousel ---- */
  (function () {
    var track = document.getElementById("testi-track");
    var dotsWrap = document.getElementById("testi-dots");
    // Both, not just the track: this IIFE runs before the product block in the
    // same file, so a throw on dotsWrap.appendChild below would take the size
    // picker and the add button down with it -- every add would then post
    // whichever variant the page loaded with.
    if (!track || !dotsWrap) return;
    var slides = track.children;
    var i = 0, timer;
    for (var s = 0; s < slides.length; s++) {
      var d = document.createElement("button");
      d.className = "testi-dot";
      d.setAttribute("aria-label", tr("testimonial_dot", "Go to testimonial [n]", { n: s + 1 }));
      (function (idx) { d.addEventListener("click", function () { goTo(idx); }); })(s);
      dotsWrap.appendChild(d);
    }
    var dots = dotsWrap.children;
    function render() {
      // RTL is handled in CSS (sections/fz-proof.liquid lays the track out
      // left-to-right with each slide back in RTL), so the maths stays as is.
      track.style.transform = "translateX(" + (-i * 100) + "%)";
      for (var s = 0; s < dots.length; s++) dots[s].classList.toggle("on", s === i);
    }
    function goTo(n) { i = (n + slides.length) % slides.length; render(); restart(); }
    function restart() { clearInterval(timer); timer = setInterval(function () { goTo(i + 1); }, 6000); }
    var nx = document.querySelector('[data-testi="next"]'), pv = document.querySelector('[data-testi="prev"]');
    if (nx) nx.addEventListener("click", function () { goTo(i + 1); });
    if (pv) pv.addEventListener("click", function () { goTo(i - 1); });
    var root = document.getElementById("testi");
    if (root) {
      root.addEventListener("mouseenter", function () { clearInterval(timer); });
      root.addEventListener("mouseleave", restart);
    }
    render(); restart();
  })();

  /* ---- Shop filters ---- */
  (function () {
    var grid = document.getElementById("shop-grid");
    var chips = document.querySelectorAll(".filter-chip");
    if (!grid || !chips.length) return;
    // The chosen filter lives in the URL, not just in the DOM. It used to be
    // DOM-only, so opening a product and pressing back dropped it: five AI
    // shoppers reapplied the Grip Socks filter over and over and read it as
    // the filter resetting itself. replaceState rather than pushState -- a
    // chip is not a page, and back should leave the collection rather than
    // walk back through every chip that was tried.
    var PARAM = "type";

    function apply(f, remember) {
      var found = false;
      chips.forEach(function (x) {
        var on = x.dataset.filter === f;
        x.classList.toggle("on", on);
        if (on) found = true;
      });
      // A type that is not in this collection (a stale link, a renamed
      // product type) falls back to All rather than hiding the whole grid.
      if (!found) {
        f = "all";
        chips.forEach(function (x) { x.classList.toggle("on", x.dataset.filter === "all"); });
      }

      var shown = 0;
      // .fzc, not .pcard: .pcard was the pre-consolidation card class and
      // exists nowhere in the theme any more, so every filter click hid
      // nothing and then wrote "0 pieces" under a full grid.
      grid.querySelectorAll(".fzc").forEach(function (card) {
        var ok = f === "all" || (card.dataset.group || "").split("|").indexOf(f) !== -1;
        card.style.display = ok ? "" : "none";
        if (ok) shown++;
      });
      var count = document.getElementById("shop-count");
      if (count) {
        // The filter only sees the page it is on -- the grid paginates at 48 --
        // so on a longer collection "12 pieces" after a click would mean
        // something different from the "60 pieces" printed before it. Say
        // which of the two it is.
        var total = parseInt(count.getAttribute("data-total"), 10) || 0;
        if (f === "all") {
          count.textContent = trn("pieces", total || shown, "[count] piece", "[count] pieces");
        } else if (total > shown && count.getAttribute("data-paginated") === "1") {
          count.textContent = trn("pieces_of", total, "[shown] of [count] pieces", "[shown] of [count] pieces", { shown: shown });
        } else {
          count.textContent = trn("pieces", shown, "[count] piece", "[count] pieces");
        }
      }
      if (remember) {
        try {
          var u = new URL(location.href);
          if (f === "all") u.searchParams.delete(PARAM);
          else u.searchParams.set(PARAM, f);
          history.replaceState(null, "", u);
        } catch (e) { /* old browser: the filter still works, it just won't survive back */ }
      }
      revealCheck();
    }

    chips.forEach(function (ch) {
      ch.addEventListener("click", function () { apply(ch.dataset.filter, true); });
    });

    // Restore on arrival, so back from a product lands on the same filtered view.
    try {
      var initial = new URL(location.href).searchParams.get(PARAM);
      if (initial) apply(initial, false);
    } catch (e) {}
  })();


  /* ---- Accordions (PDP / FAQ) ---- */
  document.querySelectorAll(".acc-head").forEach(function (h) {
    h.addEventListener("click", function () {
      var item = h.closest(".acc-item");
      var body = item.querySelector(".acc-body");
      if (item.classList.contains("open")) {
        item.classList.remove("open"); body.style.maxHeight = "0";
      } else {
        item.classList.add("open"); body.style.maxHeight = body.scrollHeight + "px";
      }
    });
  });
  document.querySelectorAll(".acc-item.open .acc-body").forEach(function (b) {
    b.style.maxHeight = b.scrollHeight + "px";
  });

  /* ---- Product page (variants, options, gallery, qty, sticky bar) ---- */
  (function () {
    var buyBox = document.getElementById("buy-box");
    if (!buyBox) return;

    var variants = [];
    try { variants = JSON.parse(document.getElementById("pdp-variants").textContent); } catch (e) {}
    var idField = document.getElementById("pdp-variant-id");
    var priceEl = document.getElementById("buy-price");
    var saPrice = document.getElementById("sa-price");
    var addBtn = document.getElementById("add-btn");
    var moneyFmt = buyBox.getAttribute("data-money") || "AED {{amount}}";
    var selected = {}; // optionName -> value

    function money(cents) {
      // Two decimals, like Liquid's `| money`. At 0 minimum, JS rewrote the
      // server-rendered "Dhs. 197.10" as "Dhs. 197.1" the moment a variant
      // was priced -- a cent short of the price beside it on every card.
      var amount = (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return moneyFmt.replace("{{amount}}", amount).replace("{{amount_no_decimals}}", Math.round(cents / 100));
    }

    function findVariant() {
      // A default-variant product renders no option controls, so `selected` is
      // empty and the option match below can never succeed -- which disabled
      // "Add to bag" and relabelled it "Unavailable" on every grip-sock page.
      if (variants.length === 1) return variants[0];
      return variants.find(function (v) {
        return v.options.every(function (opt, idx) {
          var name = v.optionNames[idx];
          return selected[name] === opt;
        });
      });
    }

    function updateVariant() {
      var v = findVariant();
      // No such combination. Returning quietly here is what let a stale price
      // stand next to a changed selection; say so and block the add instead.
      if (!v) {
        // Put the row back into a coherent state. Leaving the inline display
        // toggles untouched here could show no buy control at all, or a dead
        // sticky bar still flagged as a notify trigger.
        if (addBtn) {
          addBtn.disabled = true;
          addBtn.textContent = tr("unavailable", "Unavailable");
          addBtn.style.display = "";
        }
        var bisNone = document.getElementById("bis-btn");
        if (bisNone) bisNone.style.display = "none";
        var stepNone = document.querySelector(".qty-stepper");
        if (stepNone) stepNone.style.display = "";
        var saNone = document.getElementById("sa-btn");
        if (saNone) {
          saNone.disabled = true;
          saNone.textContent = tr("unavailable", "Unavailable");
          saNone.dataset.notify = "";
        }
        return;
      }
      if (idField) idField.value = v.id;
      // Mirrors snippets/fz-price.liquid exactly, including its integer
      // truncation -- Math.round here would drift a cent from the rendered
      // price on some amounts.
      var list = (v.compare_at_price && v.compare_at_price > v.price) ? v.compare_at_price : v.price;
      var payable = v.price;
      // Same wrapper snippets/fz-price.liquid renders, or the price loses its
      // own line on a phone the moment a variant changes.
      var html = '<span class="now">' + money(payable) + "</span>";
      if (list > payable) {
        // Labelled exactly as fz-price.liquid labels it: never a bare struck
        // figure, which reads as a price that was once charged.
        var save = Math.round(((list - payable) * 100.0) / list);
        html += '<span class="was"><span class="wasl">' + tr("was", "Was") + '</span>' + money(list) + '</span>' +
                '<span class="savechip">' + tr("save_percent", "Save [percent]%", { percent: save }) + '</span>';
      }
      if (priceEl) priceEl.innerHTML = html;
      if (saPrice) saPrice.textContent = money(payable);
      // Tabby works its instalments out from the price, so it has to hear
      // about a variant change -- "4 payments of X" for the variant you are
      // not looking at is worse than no figure at all.
      document.dispatchEvent(new CustomEvent("fz:price", { detail: { cents: payable } }));
      // The stand-in Tabby line is rendered server-side, so it needs the same
      // nudge: on a set, switching to "Bra only" otherwise left the quarter of
      // the full-set price sitting there.
      var per = document.querySelector("[data-tabby-per]");
      if (per) per.textContent = money(Math.round(payable / 4));
      if (addBtn) {
        var forceSold = buyBox.getAttribute("data-force-sold-out") === "1";
        var soldOut = forceSold || !v.available;
        addBtn.disabled = soldOut;
        addBtn.textContent = soldOut ? tr("sold_out", "Sold out") : (addBtn.getAttribute("data-add-label") || tr("add_to_bag", "Add to bag"));
        // The sticky bar is the only buy control on screen once a phone has
        // scrolled past the buy box, and it proxies its click to this button.
        // It was never re-labelled, so picking a sold-out size left it reading
        // "Add to bag" and tapping it clicked a disabled button: nothing
        // happened and nothing said why.
        var stickyBtn = document.getElementById("sa-btn");
        if (stickyBtn) {
          // Not disabled when sold out: it becomes the notify trigger. On a
          // phone this is the only control on screen once the buy box has
          // scrolled away, and a dead button there is the exact dead end
          // the notify flow exists to remove.
          stickyBtn.disabled = false;
          stickyBtn.dataset.notify = soldOut ? "1" : "";
          stickyBtn.textContent = soldOut ? tr("notify_me", "Notify me") : addBtn.textContent;
        }
        // A disabled "Sold out" button is a dead end. Swap in the notify
        // button for exactly the sizes we cannot ship, and remember which size
        // it is -- the modal records the selection made here, not the one the
        // page happened to load with.
        // Inline display, matching the Liquid. The `hidden` attribute loses
        // to `.btn { display: inline-flex }`, which is why Add to bag and
        // Notify me were both on screen at once.
        var bisBtn = document.getElementById("bis-btn");
        if (bisBtn) {
          bisBtn.style.display = soldOut ? "" : "none";
          addBtn.style.display = soldOut ? "none" : "";
          bisBtn.dataset.variant = v.title || "";
          // A quantity stepper on something you cannot buy is dead weight,
          // and on a phone it is 130px the notify label badly needs.
          var stepper = document.querySelector(".qty-stepper");
          if (stepper) stepper.style.display = soldOut ? "none" : "";
        }
      }
      // Carry the selection across a colour change. The ?variant= that
      // fz-colours renders is only the variant the PAGE was rendered with, so
      // switching to "Shorts only" and then tapping another colour still
      // landed on that product's default -- the full set, at nearly double the
      // price, with nothing saying it had changed. Variant titles match across
      // colourways of one style, so the sibling's own map resolves it.
      var vTitle = (v.options || []).join(" / ");
      document.querySelectorAll(".fzsw[data-vmap]").forEach(function (a) {
        var base = a.getAttribute("data-base");
        if (!base) return;
        var id = null;
        (a.getAttribute("data-vmap") || "").split("|").forEach(function (pair) {
          var at = pair.lastIndexOf("=");
          if (at > 0 && pair.slice(0, at) === vTitle) id = pair.slice(at + 1);
        });
        a.setAttribute("href", id ? base + "?variant=" + id : base);
      });
    }

    // The .swatch and .thumb handlers that used to sit here went with the
    // markup they drove: colour is a row of links to sibling products now
    // (snippets/fz-colours.liquid) and the gallery is three equal frames with
    // no main/thumb hierarchy. They were still querying #color-val, #gmain-img
    // and #gmain-fb, none of which any template renders, on every page load.

    // Every non-colour option renders these buttons, so a product with two of
    // them (the sets: "Buy as" and "Size") had them all in one pool. Clicking
    // "Bra only" therefore un-selected the size as well, no combination
    // matched, findVariant() returned nothing and updateVariant() bailed --
    // which is why the price sat at the full-set 235. Clear within the option
    // group only.
    document.querySelectorAll(".size").forEach(function (b) {
      b.addEventListener("click", function () {
        (b.closest(".opt") || document).querySelectorAll(".size").forEach(function (x) { x.classList.remove("active"); });
        b.classList.add("active");
        if (b.dataset.option) selected[b.dataset.option] = b.dataset.value;
        updateVariant();
      });
    });

    // Loupe on every gallery frame. Each cell carries its own hi-res source,
    // so all three zoom independently -- no main/thumb hierarchy.
    if (window.matchMedia("(hover: hover)").matches) {
      Array.prototype.forEach.call(document.querySelectorAll(".pgal-cell"), function (cell) {
        var lens = cell.querySelector(".pgal-zoom");
        var src = cell.getAttribute("data-zoom-src");
        if (!lens || !src) return;
        var expand = cell.querySelector(".pgal-expand");
        var ZOOM = 2;

        // The lens was painting before its hi-res source had downloaded, so
        // the first hover showed a blank white disc. Warm the image on
        // mouseenter (not on page load -- that is three 1600px files nobody
        // may ever ask for) and keep the lens off until it can actually
        // show something.
        var ready = false, warming = false, nw = 0, nh = 0;
        function warm() {
          if (warming) return;
          warming = true;
          var pre = new Image();
          pre.onload = function () {
            // The photo's own proportions, needed to crop the lens the way
            // the frame crops the <img>.
            nw = pre.naturalWidth; nh = pre.naturalHeight;
            ready = nw > 0 && nh > 0;
            lens.style.backgroundImage = 'url("' + src + '")';
          };
          pre.src = src;
        }
        cell.addEventListener("mouseenter", warm);

        cell.addEventListener("mousemove", function (e) {
          if (!ready) { warm(); return; }
          var r = cell.getBoundingClientRect();
          var x = e.clientX - r.left, y = e.clientY - r.top;
          if (x < 0 || y < 0 || x > r.width || y > r.height) return;
          var d = lens.offsetWidth / 2;
          // The loupe is ~190px across and centred on the pointer, so it
          // covers the expand button from half its width away -- the control
          // sat buried under the circle long before the pointer reached it.
          // Suppressing it only while exactly on the button was too late, so
          // the button's box grown by the lens radius is kept clear: the
          // circle can then never overlap the button at all.
          if (expand &&
              x > expand.offsetLeft - d && x < expand.offsetLeft + expand.offsetWidth + d &&
              y > expand.offsetTop - d && y < expand.offsetTop + expand.offsetHeight + d) {
            cell.classList.remove("zooming");
            return;
          }
          cell.classList.add("zooming");
          lens.style.left = (x - d) + "px";
          lens.style.top = (y - d) + "px";
          // The frame crops its photo with object-fit: cover, so the lens has
          // to crop it exactly the same way. Sizing the backdrop to the cell
          // instead squashed every photo whose own ratio was not the cell's
          // 3:4 -- square sock shots came out stretched, wider ones compacted
          // -- and showed a different part of the picture than the pointer
          // was over. OBJ_Y mirrors `object-position: center 15%` in
          // product.css; the two have to move together.
          var OBJ_Y = 0.15, L = lens.offsetWidth;
          var fit = Math.max(r.width / nw, r.height / nh);
          var rw = nw * fit, rh = nh * fit;                  // size as displayed
          var ox = (r.width - rw) / 2, oy = (r.height - rh) * OBJ_Y;
          var zw = rw * ZOOM, zh = rh * ZOOM;
          // Clamped so the magnified frame always fills the disc. Unclamped,
          // a pointer near any edge pushed the image out of the lens and left
          // a white crescent behind it -- at a corner, most of the circle.
          var bx = Math.min(Math.max((x - ox) * ZOOM - d, 0), Math.max(0, zw - L));
          var by = Math.min(Math.max((y - oy) * ZOOM - d, 0), Math.max(0, zh - L));
          lens.style.backgroundSize = zw + "px " + zh + "px";
          lens.style.backgroundPosition = -bx + "px " + -by + "px";
        });
        cell.addEventListener("mouseleave", function () { cell.classList.remove("zooming"); });
      });
    }

    // Quantity
    var qEl = document.getElementById("qty-val");
    var qField = document.getElementById("pdp-qty");
    var qty = 1;
    function setQty(n) { qty = Math.max(1, n); if (qEl) qEl.textContent = qty; if (qField) qField.value = qty; }
    var qi = document.getElementById("qty-inc"), qd = document.getElementById("qty-dec");
    if (qi) qi.addEventListener("click", function () { setQty(qty + 1); });
    if (qd) qd.addEventListener("click", function () { setQty(qty - 1); });

    // Seed from EVERY pre-selected control, not the first one found: with two
    // option groups, only "Buy as" was ever recorded, so the size was missing
    // from `selected` and no variant could match from the first click.
    document.querySelectorAll(".size.active").forEach(function (el) {
      if (el.dataset.option) selected[el.dataset.option] = el.dataset.value;
    });
    updateVariant();

    // Sticky add bar
    var bar = document.getElementById("sticky-add");
    if (bar) {
      // Up whenever the buy box is off screen -- BELOW the fold as well as
      // above it. It used to appear only once the shopper had scrolled past
      // the buy box, but on a phone the buy box sits 1,400px down a set page
      // (breadcrumb, title, gallery, size guide, description come first) and
      // the median set-page visit scrolls 9%: most shoppers left without ever
      // seeing a price or an Add to bag. Now both are on screen from the
      // first frame.
      var sb = function () {
        // The button, not the buy box: the box starts inside the first screen
        // (size guide, description) while its Add to bag is far below it.
        var r = (addBtn || buyBox).getBoundingClientRect();
        // exp-sticky-buy-bar: control keeps the old rule -- the bar only once
        // the button has scrolled past -- so the first-screen change can be
        // measured rather than assumed.
        var control = document.documentElement.getAttribute("data-exp-sticky-buy-bar") === "control";
        bar.classList.toggle("show", r.bottom < 0 || (!control && r.top > window.innerHeight));
      };
      window.addEventListener("scroll", sb, { passive: true }); sb();
      document.addEventListener("fz:experiment", sb);
      var saBtn = document.getElementById("sa-btn");
      if (saBtn && addBtn) saBtn.addEventListener("click", function () {
        if (saBtn.dataset.notify === "1") {
          var nb = document.getElementById("bis-btn");
          if (nb) { nb.click(); return; }
        }
        addBtn.click();
      });
    }
  })();
})();

/* ============================================================
   Autoplaying video — play what is on screen, and keep it looping.

   Every autoplay+loop clip in the theme (hero cells, the shoot reel, the
   social rail) carried its own copy of this observer: three near-identical
   blocks, none of which could recover a video the browser had paused for
   its own reasons. One place now, matched on the attributes themselves so
   a clip added later is covered without wiring anything up.
   ============================================================ */
(function () {
  "use strict";
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  // Marked, not `autoplay`. With the attribute the browser starts every clip
  // on the page the moment it can -- including ones a phone has hidden -- and
  // this observer only got to pause them after they had begun streaming. A
  // homepage load on a 390px viewport pulled 120MB of video that way. Now
  // nothing loads until the observer says so, and `preload="none"` means
  // nothing is fetched before that either.
  var SEL = "video[data-fz-autoplay]";
  function all() { return Array.prototype.slice.call(document.querySelectorAll(SEL)); }
  function onScreen(v) {
    var r = v.getBoundingClientRect();
    return r.bottom > 0 && r.top < window.innerHeight && r.right > 0 && r.left < window.innerWidth;
  }
  function play(v) {
    // Safari checks the muted PROPERTY when it decides whether an inline
    // autoplay is allowed, and a video restored from the bfcache can come
    // back unmuted. Setting it again costs nothing and is the difference
    // between playing and showing a play button on iOS.
    v.muted = true;
    v.playsInline = true;
    var p = v.play();
    if (p && p.catch) {
      p.catch(function () {
        // First attempt can be refused while the media has no data yet with
        // preload="none". One retry when it is ready, then leave the poster.
        v.addEventListener("loadeddata", function once() {
          v.removeEventListener("loadeddata", once);
          var q = v.play();
          if (q && q.catch) q.catch(function () {});
        });
        v.load();
      });
    }
  }
  function resume() { all().forEach(function (v) { if (v.paused && onScreen(v)) play(v); }); }

  var vids = all();
  if (!vids.length) return;

  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) play(e.target);
        else e.target.pause();
      });
    }, { threshold: 0.12 });
    vids.forEach(function (v) { io.observe(v); });
  } else {
    vids.forEach(play);
  }

  vids.forEach(function (v) {
    // `loop` is what should wrap these; this is the safety net under it. A
    // clip can still fire `ended` instead of wrapping -- a short final frame,
    // a range request answered oddly, iOS Low Power Mode -- and then the hero
    // holds one still frame for the rest of the visit.
    v.addEventListener("ended", function () {
      if (!onScreen(v)) return;
      try { v.currentTime = 0; } catch (e) { /* not seekable yet; play() still restarts it */ }
      play(v);
    });
  });

  // None of the above fires when the tab is hidden and shown again, or when
  // the page returns from the bfcache: the intersection never changed, so the
  // observer stays silent while the browser has quietly paused the video.
  document.addEventListener("visibilitychange", function () { if (!document.hidden) resume(); });
  window.addEventListener("pageshow", resume);
})();


/* ---- Back-in-stock modal ------------------------------------------------
   Opens on the notify button, writes the requested colour and size into the
   customer form as a tag, and posts through Shopify's own customer endpoint.
   No app and no third-party key: the email lands in Customers tagged with what
   it was waiting for, which is what makes the list readable as a reorder spec. */
(function () {
  var modal = document.getElementById("fz-bis");
  if (!modal) return;
  // UI strings from snippets/fz-strings.liquid; the English here is the
  // fallback for a key that is missing.
  var fzT = window.fzT || {};
  function fillIn(s, o) { s = String(s); for (var x in o) s = s.split("[" + x + "]").join(o[x]); return s; }
  function tr(k, en, o) { return fillIn(fzT[k] || en, o); }

  var btn = document.getElementById("bis-btn");
  var tags = document.getElementById("fzb-tags");
  var note = document.getElementById("fzb-note");
  var what = document.getElementById("fzb-what");
  var email = document.getElementById("fzb-email");
  var product = modal.dataset.product || "";
  var alts = document.getElementById("fzb-alts");
  var altsSub = document.getElementById("fzb-alts-sub");
  var altItems = alts ? [].slice.call(alts.querySelectorAll(".fzb-alt")) : [];

  function slug(s) {
    return String(s).toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
  }

  // "Full set / S" -> "S", "M" -> "M". Only ever for display: the MATCH is on
  // the whole variant title, because "Bra only / S" and "Full set / S" are
  // different things at different prices and must not be offered for one
  // another. Splitting for the caption keeps the sentence readable.
  function sizeLabel(title) {
    var bits = String(title).split(" / ");
    return bits[bits.length - 1];
  }

  // fz-card ships its images loading="lazy", which is right everywhere else and
  // wrong here: an image that has only ever existed inside a display:none
  // overlay is never scheduled, and opening the modal does not wake it. The row
  // rendered as three empty frames -- the exact opposite of the point, which is
  // that a photograph shows you what the colour actually looks like.
  //
  // Measured on a live PDP: setting loading="eager" after parse does NOT start
  // the fetch. The attribute has to come off. Removing it took the row from
  // 0/9 loaded to 9/9.
  //
  // Per card, once, and only when we have decided to show it -- so a modal that
  // is never opened still costs nothing.
  function wake(li) {
    if (li.dataset.woke) return;
    li.dataset.woke = "1";
    li.querySelectorAll("img[loading]").forEach(function (img) {
      img.removeAttribute("loading");
    });
  }

  // Show the colourways that can actually ship the variant that was just
  // refused. If none can, fall back to every colourway with stock rather than
  // showing an empty row -- a shopper who cannot have M in any colour may well
  // still take L, and the alternative is a dead modal.
  function syncAlts(size) {
    if (!alts || !altItems.length) return;
    var shown = 0;
    altItems.forEach(function (li) {
      // Pipe-wrapped on both sides by the Liquid, so indexOf is an exact
      // whole-title test: "|S|" cannot match inside "|XS|".
      var haystack = li.dataset.sizes || "";
      var hit = !size || haystack.indexOf("|" + size + "|") > -1;
      li.hidden = !hit;
      if (hit) { shown++; wake(li); }
    });
    var exact = shown > 0;
    if (!exact) {
      altItems.forEach(function (li) { li.hidden = false; wake(li); });
      shown = altItems.length;
    }
    if (altsSub) {
      if (!size) altsSub.textContent = "";
      else if (exact) altsSub.textContent = tr("in_stock_in", "In stock in [size]", { size: sizeLabel(size) });
      else altsSub.textContent = tr("no_colour_has", "No colour has [size] right now \u2014 the rest of the style:", { size: sizeLabel(size) });
    }
    alts.hidden = shown === 0;
    modal.classList.toggle("has-alts", shown > 0);
  }

  // Scroll lock. The class alone was not enough: `overflow: hidden` on <body>
  // does not hold when <html> is the scroller, and iOS ignores it outright, so
  // the page carried on scrolling behind the open modal. Position-fixing the
  // body is what actually stops it -- the same mechanism the mobile menu a few
  // hundred lines up already uses. The offset is saved and restored, or opening
  // the modal would silently throw the shopper back to the top of the page.
  var savedY = 0, locked = false;
  function lockScroll() {
    if (locked) return;
    locked = true;
    savedY = window.scrollY || document.documentElement.scrollTop || 0;
    document.body.style.position = "fixed";
    document.body.style.top = -savedY + "px";
    document.body.style.left = "0";
    document.body.style.right = "0";
    document.body.style.width = "100%";
    document.body.classList.add("fzb-lock");
  }
  function unlockScroll() {
    if (!locked) return;
    locked = false;
    document.body.classList.remove("fzb-lock");
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.left = "";
    document.body.style.right = "";
    document.body.style.width = "";
    window.scrollTo(0, savedY);
  }

  function open() {
    var size = (btn && btn.dataset.variant) || "";
    var label = size ? product + " \u2014 " + size : product;
    if (what) what.textContent = label;
    if (tags) tags.value = "back-in-stock, bis-" + slug(product + " " + size);
    // first_name is the only free-text field Shopify's customer form accepts,
    // so it carries the readable request onto the customer record itself.
    if (note) note.value = label;
    // Before the paint, so the dialog opens at its final width instead of
    // snapping from 420px once the row appears.
    syncAlts(size);
    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    lockScroll();
    if (email) setTimeout(function () { email.focus(); }, 60);
  }

  function close() {
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    unlockScroll();
  }

  if (btn) btn.addEventListener("click", open);
  modal.querySelectorAll("[data-fzb-close]").forEach(function (el) {
    el.addEventListener("click", close);
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && modal.classList.contains("is-open")) close();
  });

  // Shopify redirects back with ?customer_posted=true after a successful
  // signup; reopen so the confirmation is seen rather than lost in the reload.
  if (/[?&]customer_posted=true/.test(window.location.search)) {
    var ask = document.getElementById("fzb-ask");
    var done = document.getElementById("fzb-done");
    if (ask) ask.hidden = true;
    if (done) done.hidden = false;
    // The reload lost the size that was selected, so this shows every
    // colourway still in stock. Kept deliberately: "you're on the list" is the
    // best moment to offer one they can have today.
    syncAlts("");
    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    // This path opened the modal without ever locking, so the page scrolled
    // behind the confirmation exactly as it did behind the form.
    lockScroll();
  }
})();

/* ---- WhatsApp click-to-chat ----
   Every entry point is snippets/whatsapp-link.liquid. wa.me opens the
   WhatsApp app: right on a phone, wrong on a laptop, where it tries the
   desktop app most customers do not have -- a dead click or an "open app?"
   dialog, and a lost enquiry. So: the app on mobile, WhatsApp Web in a new
   tab everywhere else.
   Decided once on load and written into the real href, not intercepted per
   click. The device does not change mid-visit, and a real href means
   long-press, middle-click and "copy link" all get the right URL as well.
   An iPad on iPadOS reports a desktop user agent and so gets WhatsApp Web,
   which works in its browser whether or not the app is installed.
   Its own top-level block on purpose: the back-in-stock block above opens
   with `if (!modal) return;`, so code placed inside it runs on product
   pages only. */
(function () {
  var links = document.querySelectorAll("a[data-whatsapp]");
  if (!links.length) return;
  var uaData = navigator.userAgentData;
  var mobile = uaData && typeof uaData.mobile === "boolean"
    ? uaData.mobile
    : /android|iphone|ipad|ipod|iemobile|opera mini/i.test(navigator.userAgent);
  Array.prototype.forEach.call(links, function (a) {
    var phone = a.getAttribute("data-whatsapp");
    var text = encodeURIComponent(a.getAttribute("data-whatsapp-message") || "");
    a.href = mobile
      ? "https://wa.me/" + phone + (text ? "?text=" + text : "")
      : "https://web.whatsapp.com/send?phone=" + phone + (text ? "&text=" + text : "");
  });
  // Attributed, so an enquiry can be traced to the page it started on.
  document.addEventListener("click", function (e) {
    var a = e.target.closest && e.target.closest("a[data-whatsapp]");
    if (!a) return;
    var where = { location: a.getAttribute("data-whatsapp-location") || "unknown" };
    try { if (window.gtag) window.gtag("event", "whatsapp_click", where); } catch (err) {}
    try { if (window.posthog && window.posthog.capture) window.posthog.capture("whatsapp_click", where); } catch (err) {}
  });
})();

/* ---- exp-socks-lead-bundle ----
   The socks landing grid carries a Studio Trio card rendered hidden
   (sections/main-collection.liquid). The bundle-first variant reveals it at
   the top; control and anyone outside the rollout never see it. */
(function () {
  function reveal() {
    // Two-way, so a variant that changes after the first reveal (a test
    // override) hides the card again instead of leaving it up.
    var on = document.documentElement.getAttribute("data-exp-socks-lead-bundle") === "bundle-first";
    Array.prototype.forEach.call(document.querySelectorAll("[data-exp-lead]"), function (el) { el.hidden = !on; el.style.order = on ? "-1" : ""; });
  }
  reveal();
  document.addEventListener("fz:experiment", reveal);
})();
